import React from "react";

import PageLayout from "@layout/PageLayout";

import HomePageBody from "./HomePageBody";
import { transformHomePageData } from "./transformHomePageData";
import {
	renderRichText,
	bulkRenderRichText,
} from "@utils/prismic-render-utils";

const renderRichTextFields = data => {
	const richTextData = bulkRenderRichText(data, [
		"timelineItems",
		"additionalInformationGroups",
		"maps",
	]);
	const timelineItems = data.timelineItems.map(event => ({
		...event,
		description: renderRichText(event.description),
	}));
	const additionalInformationGroups = data.additionalInformationGroups.map(
		group => ({
			...group,
			header: renderRichText(group.header),
		})
	);
	return {
		...data,
		...richTextData,
		timelineItems: timelineItems,
		additionalInformationGroups: additionalInformationGroups,
	};
};

const IndexPage = props => {
	const data = props.previewData
		? renderRichTextFields(transformHomePageData(props.previewData))
		: renderRichTextFields(props.pageContext.data);

	return (
		<PageLayout
			{...props}
			data={data}
			tocQuery="h2,h3"
			pageTitle="Home"
			renderPage={pageProps => <HomePageBody {...pageProps} />}
		/>
	);
};

export default IndexPage;
